import type { ErrorCopy } from '@shared/errors/catalog';

import { contentErrors } from '../_shared/errors';

/**
 * The codes this surface meets. Every one is already in the owning service's
 * catalogue — the list raises nothing of its own — so the map is that
 * catalogue, named here so the surface reads from a catalogue rather than from
 * a spread at a call site.
 *
 * The two that matter most on this route are
 * `CONTENT_INVALID_STATE_TRANSITION`, which is the row having moved between
 * load and click, and `CONTENT_REQUIRED_METADATA_MISSING`, whose `details[]`
 * names each outstanding field so the toast can list them instead of repeating
 * one sentence.
 */
export const errors: Readonly<Record<string, ErrorCopy>> = contentErrors;
